import React, { useMemo, useState } from "react";
import { Space, Avatar, Typography, Button } from "antd";
import VerifyIcon from "../../assets/icons/verify.svg";
import CrossIcon from "../../assets/icons/close-with-shadow.svg";
import { generateImageAltText } from "../../utls/imageAltGenerator";
import "./index.less";

type props = {
  className?: string;
  size: number;
  image: string | undefined;
  name?: string;
  username?: string;
  usernameAltText?: string;
  firstName?: string;
  lastName?: string;
  fontSize?: number;
  fontWeight?: boolean;
  lineHeight?: number;
  isShowVeritify?: boolean;
  fromSuggestions?: boolean;
  isLive?: boolean;
  isLargeView?: boolean;
  onClick?: () => void;
  profileName?: string;
};

const AvatarComponent: React.FC<props> = ({
  className,
  size,
  image,
  name,
  username,
  usernameAltText,
  fontSize,
  fontWeight,
  lineHeight,
  isShowVeritify,
  onClick,
  firstName,
  lastName,
  fromSuggestions,
  isLive = false,
  isLargeView = false,
  profileName,
}) => {
  const [isImageLarge, setIsImageLarge] = useState(false);

  const handleAvatarClick = () => {
    if (isLargeView) {
      setIsImageLarge(!isImageLarge);
    }
    if (onClick) onClick();
  };

  const altText = useMemo(
    () =>
      generateImageAltText({
        name: profileName || name,
        username: usernameAltText,
        index: 0,
        fallback: "avatar",
      }),
    [profileName, name, usernameAltText]
  );

  return (
    <>
      <Space className={`${className} gap-10`} direction="vertical" align="center">
        <Space className={`avatarWrap ${isLive ? "live-border" : ""}`}>
          <div className={`${isLive ? "avatarBorder" : ""}`} title={altText}>
            <Avatar
              className="avatar"
              size={size}
              src={image !== undefined ? image : ""}
              alt={altText}
              onClick={handleAvatarClick} // Utiliser handleAvatarClick pour gérer le clic
            />
            {isLive && <div className="live-badge">LIVE</div>}
          </div>
        </Space>
        {username && (
          <Space align="center">
            <Typography.Text
              className={`responsive-name text-white-color ${fontWeight ? "primary-font-bold" : "primary-font-regular"}`}
              style={{
                fontSize: fontSize,
                lineHeight: `${lineHeight}px`,
              }}
            >
              {name ? name : username}
            </Typography.Text>
            {isShowVeritify && <img src={VerifyIcon} alt="verify" />}
          </Space>
        )}
      </Space>

      {isImageLarge && (
        <div className="avatar-image-overlay" onClick={() => setIsImageLarge(false)}>
          <img className="cross-icon" src={CrossIcon} alt="close" title="close" />
          <img className="avatar-large-image" src={image} alt={altText} title={altText} />
        </div>
      )}
    </>
  );
};

export default AvatarComponent;
